import { UseCase } from '@mdd/api';
import { User } from '../../models';

export class HasDanoneMemberCenterAccess implements UseCase<User | undefined, boolean> {
    execute(user: User | undefined): boolean {
        return !!user && user.permissions.includes('DANONE_MEMBER_CENTER');
    }
}
